const initialState = {
  generalData: {},
  subjectData: {},
  classData: {},
  sectionsData: {},
};

export default function prePostReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_GENERAL_DATA':
      return { ...state, generalData: action.payload };
    case 'SET_SUBJECT_DATA':
      return { ...state, subjectData: action.payload };
    case 'SET_CLASS_DATA':
      return { ...state, classData: action.payload };
    case 'SET_SECTIONS_DATA':
      return { ...state, sectionsData: action.payload };
    default:
      return state;
  }
}